export const taskTypeColumns = [
  {
    title: 'Task Type',
    key: 'title',
    dataIndex: 'title'
  }
];
